import { forwardRef } from "react"
import styled from "@emotion/styled"
import { motion, useTransform, transform } from "framer-motion"

import { useConsole } from "contexts/Console"
import { useViewport } from "contexts/Viewport"

import useSSR from "hooks/useSSR"

import { headline70, surtitle70 } from "css/text"
import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"

import { fontColorVar } from "../colors"
import { useValue } from "./context"

const Root = styled(motion.div)`
  position: relative;
  grid-column: doc;
  align-items: center;
  margin-block-start: -200vh;
  ${fullGrid}

  transform: translate3d(0, 0, 0);
`

const Container = styled.div`
  ${fullGrid}
  grid-column: doc;
  transform: translate3d(0, 0, 0);
`

const Header = styled(motion.hgroup)`
  display: block;
  position: relative;
  color: white;
  grid-column: col 1 / span 6;

  padding-block-start: 130vh;
  padding-block-end: 30vh;

  ${getMediaQuery("m")} {
    grid-column: col 4 / span 6;
  }

  & h2 {
    ${headline70}
    transform: translate3d(0, 0, 0);

    & em {
      font-style: normal;
    }
  }
  & p {
    ${surtitle70}
    margin-block-end: 10px;
    transform: translate3d(0, 0, 0);
  }

  @media (prefers-contrast: no-preference) {
    & em {
      color: var(${fontColorVar});
    }
    & p {
      color: var(${fontColorVar});
    }
  }
`

function FeatureIntro({ template_title, template_text, index }, ref) {
  const console = useConsole()
  const ssr = useSSR()

  const { height } = useViewport()

  const { globalProg, inputMap } = useValue()

  const y = useTransform([globalProg, inputMap, height], ([p, inp, h]) => {
    const i = inp.split(",").map(str => Number(str))
    const ii = [i[index - 1], i[index + 1]]
    return transform(p, ii, ["-25vh", "15vh"])
  })

  const opacity = useTransform([globalProg, inputMap, height], ([p, inp, h]) => {
    /**  guarantez same start up value as SSR */
    if (ssr) {
      return 1
    } // TODO: what are the good starting values ?

    const i = inp.split(",").map(str => Number(str))
    const ii = [i[index], i[index + 1] - h * 0.5, i[index + 1] - h * 0.2]
    return transform(p, ii, [1, 1, 0])
  })

  return (
    <Root ref={ref}>
      <Container>
        <Header style={{ y, opacity }}>
          <p dangerouslySetInnerHTML={{ __html: template_title }} />
          <h2 dangerouslySetInnerHTML={{ __html: template_text }} />
        </Header>
      </Container>
    </Root>
  )
}

export default forwardRef(FeatureIntro)
